// @core/api/endpoints/userprofile/delete_userprofile_by_user_id.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/userprofile';

/**
 * Delete user profile by user ID
 * Deletes all profiles associated with a user account. Typically used during account deletion to clean up all user data.
 */
export async function DeleteUserprofileByUserID(
  user_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/user/:user_id`;
  requestPath = requestPath.replace(':user_id', encodeURIComponent(user_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
